import { BannerRepository } from '../../domain/repositories/banner.repository';
import { BannerEntity } from '../../domain/entities/banner.entity';

export class GetBannersUseCase {
  constructor(private readonly bannerRepository: BannerRepository) {}

  async execute(onlyActive: boolean = true): Promise<BannerEntity[]> {
    return this.bannerRepository.getBanners(onlyActive);
  }
}
